const JaffeActions = flux.createActions([
  // CardAccountTrust Documents
  'fetchCardAccountTrustDocumentsAndFolders',
  'updateCardAccountTrustDocument',
  'destroyCardAccountTrustDocument',
  'dropzoneCardAccountTrustDocumentUploadSuccess',
]);

export default JaffeActions;
